module.exports = __webpack_public_path__ + "static/energy_19-8c7a7b97801999414af8552d5dc58d7f.jpg";